<template>
    <section class="dp-layout lost-found-record-page">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" pane-title="组织架构" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <template v-if="schoolId > 0">
                <div class="filter-bar">
                    <el-form :inline="true" size="small" class="filter-form">
                        <el-form-item label="关键字">
                            <el-input
                                v-model="filterForm.keyword"
                                placeholder="物品/捡拾学生/领取学生"
                                clearable
                                style="width: 200px;"
                                @keyup.enter.native="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="filterForm.statusKey" placeholder="全部状态" clearable style="width: 120px;" @change="handleSearch">
                                <el-option label="公示中" value="0" />
                                <el-option label="已领取" value="1" />
                                <el-option label="已作废" value="2" />
                                <el-option label="已过期" value="expired" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发布时间">
                            <el-date-picker
                                v-model="dateRange"
                                type="daterange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                style="width: 240px;"
                                @change="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>

                    <div class="action-btn-group">
                        <el-button v-if="hasActionPermission('handleExport')" type="success" size="small" icon="el-icon-download" :loading="exporting" @click="handleExport">
                            导出
                        </el-button>
                    </div>
                </div>

                <div class="tbl-scroll-host">
                    <el-table :data="tableData" v-loading="loading" border style="width: 100%;" height="100%" class="compact-table record-table">
                        <el-table-column type="index" label="#" width="50" align="center" />
                        <el-table-column label="物品" min-width="140">
                            <template slot-scope="scope">
                                <div class="item-cell">
                                    <oss-el-image
                                        v-if="scope.row.CoverUrl"
                                        :src="scope.row.CoverUrl"
                                        :school-id="schoolId"
                                        fit="cover"
                                        class="cover-thumb"
                                    />
                                    <div v-else class="cover-thumb cover-thumb--empty">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                    <div class="item-cell__text">
                                        <div class="item-cell__name" :title="scope.row.ItemName">{{ scope.row.ItemName || '-' }}</div>
                                        <div v-if="scope.row.Remark" class="item-cell__remark" :title="scope.row.Remark">{{ scope.row.Remark }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" min-width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="statusTagType(scope.row)" size="mini">{{ statusText(scope.row) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ClassName" label="捡拾班级" min-width="110" show-overflow-tooltip />
                        <el-table-column prop="FinderStudentName" label="捡拾学生" min-width="90" show-overflow-tooltip />
                        <el-table-column prop="PublishTeacherName" label="发布教师" min-width="90" show-overflow-tooltip />
                        <el-table-column label="发布时间" min-width="140" align="center">
                            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>
                        </el-table-column>
                        <el-table-column label="领取学生" min-width="90" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.ClaimStudentName || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="点评" min-width="80" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="evalTagType(scope.row.EvaluationStatus)" size="mini">
                                    {{ evalStatusText(scope.row.EvaluationStatus) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200" align="center" fixed="right">
                            <template slot-scope="scope">
                                <div class="table-op-pair">
                                    <el-button type="text" size="small" class="table-op-link" @click="openDetail(scope.row)">详情</el-button>
                                    <el-button v-if="hasActionPermission('openEdit')" type="text" size="small" class="table-op-link" @click="openEdit(scope.row)">编辑</el-button>
                                    <el-dropdown v-if="hasMoreAction(scope.row)" trigger="click" @command="cmd => handleRowCommand(cmd, scope.row)">
                                        <el-button type="text" size="small" class="table-op-link">更多</el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-if="scope.row.Status === 1 && hasActionPermission('handleCancelClaim')" command="cancelClaim">撤销核销</el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.EvaluationStatus === 2 && hasActionPermission('handleRetryEval')" command="retryEval">补发点评</el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.Status !== 2 && hasActionPermission('openVoidDialog')" command="void" divided style="color: #F56C6C;">作废</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <el-col :span="24" class="toolbar">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handlePageChange"
                        style="float: right;"
                    />
                </el-col>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择所属学校，查看失物记录</p>
                </div>
            </div>
        </section>

        <!-- 详情 -->
        <el-dialog title="失物详情" :visible.sync="detailVisible" width="640px" :close-on-click-modal="false" custom-class="lost-found-detail-dialog">
            <div v-loading="detailLoading" class="detail-dialog-body" element-loading-text="加载中...">
                <template v-if="detail">
                    <table class="detail-table">
                        <tr>
                            <th>物品名称</th><td>{{ detail.ItemName }}</td>
                            <th>状态</th>
                            <td><el-tag :type="statusTagType(detail)" size="mini">{{ statusText(detail) }}</el-tag></td>
                        </tr>
                        <tr>
                            <th>捡拾班级</th><td>{{ detail.ClassName || '-' }}</td>
                            <th>捡拾学生</th><td>{{ detail.FinderStudentName || '-' }}</td>
                        </tr>
                        <tr>
                            <th>发布教师</th><td>{{ detail.PublishTeacherName || '-' }}</td>
                            <th>发布时间</th><td>{{ detail.CreateTime || '-' }}</td>
                        </tr>
                        <tr>
                            <th>领取学生</th><td>{{ detail.ClaimStudentName || '-' }}</td>
                            <th>领取班级</th><td>{{ detail.ClaimClassName || '-' }}</td>
                        </tr>
                        <tr>
                            <th>核销教师</th><td>{{ detail.ClaimTeacherName || '-' }}</td>
                            <th>领取时间</th><td>{{ detail.ClaimTime || '-' }}</td>
                        </tr>
                        <tr>
                            <th>点评状态</th>
                            <td>
                                <el-tag :type="evalTagType(detail.EvaluationStatus)" size="mini">
                                    {{ evalStatusText(detail.EvaluationStatus) }}
                                </el-tag>
                            </td>
                            <th>实际加分</th>
                            <td>
                                <el-tag
                                    v-if="detail.EvaluationScore != null"
                                    :type="detail.EvaluationScore > 0 ? 'success' : 'info'"
                                    size="mini"
                                >
                                    {{ detail.EvaluationScore }}
                                </el-tag>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <th>备注</th><td colspan="3">{{ detail.Remark || '-' }}</td>
                        </tr>
                        <tr v-if="detail.EvaluationFailureReason">
                            <th>点评失败原因</th><td colspan="3">{{ detail.EvaluationFailureReason }}</td>
                        </tr>
                        <tr v-if="detail.VoidReason">
                            <th>作废原因</th><td colspan="3">{{ detail.VoidReason }}</td>
                        </tr>
                    </table>
                    <div class="photo-block" v-if="detailPhotoUrls.length">
                        <div class="photo-block__title">全部照片</div>
                        <div class="photo-list">
                            <oss-el-image
                                v-for="(url, idx) in detailPhotoUrls"
                                :key="idx"
                                :src="url"
                                :school-id="schoolId"
                                fit="cover"
                                class="photo-item"
                                :preview-src-list="detailPhotoUrls"
                            />
                        </div>
                    </div>
                </template>
                <div v-else-if="!detailLoading" class="detail-empty">暂无详情数据</div>
            </div>
            <div slot="footer">
                <el-button @click="detailVisible = false">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 编辑名称/备注/照片 -->
        <el-dialog title="编辑失物信息" :visible.sync="editVisible" width="560px" :close-on-click-modal="false">
            <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px" size="small">
                <el-form-item label="物品名称" prop="ItemName">
                    <el-input v-model="editForm.ItemName" maxlength="100" show-word-limit />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.Remark" type="textarea" :rows="3" maxlength="500" show-word-limit />
                </el-form-item>
                <el-form-item label="照片" required>
                    <el-upload
                        :key="'edit-upload-' + editUploadKey"
                        action="#"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="editFileList"
                        :limit="9"
                        accept="image/jpeg,image/jpg,image/png,image/webp"
                        :on-change="onEditFileChange"
                        :on-remove="onEditFileRemove"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="sub-hint">支持 1～9 张图片；保存时将重新上传新选文件</span>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" :loading="submitting" @click="submitEdit">保 存</el-button>
            </div>
        </el-dialog>

        <!-- 作废 -->
        <el-dialog title="作废失物记录" :visible.sync="voidVisible" width="480px" :close-on-click-modal="false">
            <el-alert
                title="作废后记录将从公示与统计中排除。若已成功自动加分，系统将同步冲正；加分已结转个人积分时可能无法作废。"
                type="warning"
                :closable="false"
                show-icon
                style="margin-bottom: 14px;"
            />
            <el-form :model="voidForm" :rules="voidRules" ref="voidForm" label-width="90px" size="small">
                <el-form-item label="作废原因" prop="Reason">
                    <el-input v-model="voidForm.Reason" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请填写作废原因" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="voidVisible = false">取 消</el-button>
                <el-button type="danger" :loading="submitting" @click="submitVoid">确认作废</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import OssElImage from '../../components/OssElImage.vue';
import { uploadPic, stripOssPresignParams, getUploadSchoolId } from '../../utils/ossMediaUpload';
import {
    batchResolveOssMediaUrls,
    isAliyunOssHttpsUrl,
    stripOssUrlQuery,
    lookupCachedOssSignedUrl,
    resolveMediaUrl
} from '../../utils/mediaUrl';
import { getButtonList } from '../../promissionRouter';
import {
    getLostAndFoundListPage,
    getLostAndFoundDetail,
    updateLostAndFound,
    cancelLostAndFoundClaim,
    voidLostAndFound,
    retryLostAndFoundEvaluation,
    exportLostAndFound
} from '../../api/modules/lostAndFound';
import {
    normalizeDeptId,
    treeNodeDeptId,
    deptIdsEqual,
    resolveActiveSchoolId,
} from '../../utils/deptCascaderProps';

export default {
    name: 'LostAndFoundRecord',
    components: { DepartmentPane, OssElImage },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            boundSchoolId: 0,
            buttonList: [],
            filterForm: {
                keyword: '',
                statusKey: null,
                campusId: null,
                classId: null,
                classIds: null
            },
            dateRange: null,
            tableData: [],
            page: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            exporting: false,
            submitting: false,

            detailVisible: false,
            detailLoading: false,
            detail: null,

            editVisible: false,
            editOpening: false,
            editUploadKey: 0,
            editForm: {
                Id: 0,
                ItemName: '',
                Remark: ''
            },
            editRules: {
                ItemName: [{ required: true, message: '请输入物品名称', trigger: 'blur' }]
            },
            editFileList: [],

            voidVisible: false,
            voidForm: {
                Id: 0,
                Reason: ''
            },
            voidRules: {
                Reason: [{ required: true, message: '请填写作废原因', trigger: 'blur' }]
            }
        };
    },
    computed: {
        detailPhotoUrls() {
            if (!this.detail) return [];
            return this.extractPhotoUrls(this.detail);
        }
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            this.applySchoolChange(newSchoolId, this.$store.state.activeSchoolName);
        }
    },
    methods: {
        /** 判断当前页面是否配置了指定按钮权限 */
        hasActionPermission(func) {
            return this.buttonList.some(button => button.Func === func);
        },

        /** 当前记录是否存在有权限的更多操作 */
        hasMoreAction(row) {
            return (row.Status === 1 && this.hasActionPermission('handleCancelClaim'))
                || (row.EvaluationStatus === 2 && this.hasActionPermission('handleRetryEval'))
                || (row.Status !== 2 && this.hasActionPermission('openVoidDialog'));
        },

        /** 兼容详情模型中的照片对象与旧版 URL 数组 */
        extractPhotoUrls(detail) {
            if (!detail) return [];
            const photos = detail.Photos || detail.photos;
            if (Array.isArray(photos) && photos.length) {
                const urls = photos
                    .map(photo => (typeof photo === 'string' ? photo : (photo.Url || photo.url)))
                    .filter(Boolean);
                if (urls.length) return urls;
            }
            const photoUrls = detail.PhotoUrls || detail.photoUrls;
            if (Array.isArray(photoUrls) && photoUrls.length) return photoUrls.filter(Boolean);
            const coverUrl = detail.CoverUrl || detail.coverUrl;
            return coverUrl ? [coverUrl] : [];
        },

        /**
         * 编辑回填照片：OSS 私有桶先预签名再给 el-upload 展示。创建于 2026-09-16
         */
        async buildEditFileList(urls) {
            const paths = (urls || []).map(u => String(u || '').trim()).filter(Boolean);
            if (!paths.length) return [];

            const schoolId = this.schoolId || getUploadSchoolId(this);
            const ossPaths = paths.filter(p => isAliyunOssHttpsUrl(stripOssUrlQuery(p)));
            if (ossPaths.length && schoolId) {
                try {
                    await batchResolveOssMediaUrls(ossPaths, schoolId, { inline: true });
                } catch (e) {
                    // 预签失败时仍回退原路径，避免阻断编辑
                }
            }

            return paths.map((raw, idx) => {
                const stable = stripOssUrlQuery(raw);
                let display = resolveMediaUrl(stable);
                if (isAliyunOssHttpsUrl(stable) && schoolId) {
                    display = lookupCachedOssSignedUrl(schoolId, stable, true) || display;
                }
                return {
                    name: `photo-${idx + 1}`,
                    url: display,
                    status: 'success',
                    uid: `${Date.now()}_${idx}`
                };
            });
        },

        /** 从 Blob 错误响应中读取后端提示 */
        readBlobMessage(blob) {
            return new Promise(resolve => {
                if (!blob) {
                    resolve('');
                    return;
                }
                const reader = new FileReader();
                reader.onload = () => {
                    const text = String(reader.result || '');
                    try {
                        const result = JSON.parse(text);
                        resolve(result.msg || result.message || text);
                    } catch (e) {
                        resolve(text);
                    }
                };
                reader.onerror = () => resolve('');
                reader.readAsText(blob);
            });
        },

        /** 解析当前学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            const local = normalizeDeptId(this.schoolId);
            if (local) return local;
            return '';
        },

        /** 当前登录操作人信息 */
        getOperator() {
            try {
                const user = JSON.parse(window.localStorage.user || '{}');
                return {
                    operatorId: user.uID || user.uId || 0,
                    operatorName: user.uRealName || user.uLoginName || '管理员'
                };
            } catch (e) {
                return { operatorId: 0, operatorName: '管理员' };
            }
        },

        statusText(row) {
            if (!row) return '-';
            if (row.Status === 2) return '已作废';
            if (row.IsExpired) return row.Status === 1 ? '已领取(过期)' : '已过期';
            if (row.Status === 1) return '已领取';
            if (row.Status === 0) return '公示中';
            return '-';
        },

        statusTagType(row) {
            if (!row) return 'info';
            if (row.Status === 2) return 'danger';
            if (row.IsExpired) return 'info';
            if (row.Status === 1) return 'success';
            return '';
        },

        evalStatusText(status) {
            if (status === 1) return '成功';
            if (status === 2) return '失败';
            if (status === 3) return '已冲正';
            return '不加分';
        },

        evalTagType(status) {
            if (status === 1) return 'success';
            if (status === 2) return 'danger';
            if (status === 3) return 'info';
            return 'info';
        },

        /** 列表时间展示：去掉秒，空值显示 - */
        formatDateTime(value) {
            if (!value) return '-';
            const text = String(value).replace('T', ' ');
            return text.length >= 16 ? text.slice(0, 16) : text;
        },

        /** 从树节点向上解析指定组织类型 Id */
        findAncestorDeptId(node, orgType) {
            let cur = node;
            const target = String(orgType || '').toLowerCase();
            while (cur) {
                const data = cur.data || cur;
                const type = String((data.DeptOrgType || data.deptOrgType) || '').toLowerCase();
                if (type === target) {
                    return treeNodeDeptId(data);
                }
                cur = cur.parent;
            }
            return '';
        },

        /**
         * 顶栏切换学校时换校并清空组织范围。最后更新：2026-09-16
         */
        applySchoolChange(schoolId, schoolName) {
            const id = normalizeDeptId(schoolId);
            if (!id) return;
            const sameSchool = deptIdsEqual(id, this.schoolId) && deptIdsEqual(this.boundSchoolId, id);
            this.schoolId = id;
            this.boundSchoolId = id;
            if (schoolName) this.schoolName = schoolName;
            if (!sameSchool) {
                this.filterForm.campusId = null;
                this.filterForm.classId = null;
                this.filterForm.classIds = null;
                this.page = 1;
                this.loadTableData();
            }
        },

        /**
         * 收集部门节点下全部行政班 Id（含自身）。创建于 2026-10-16
         */
        collectClassIdsFromDeptData(data) {
            const ids = [];
            const seen = new Set();
            const walk = (row) => {
                if (!row) return;
                const type = String(row.DeptOrgType || row.deptOrgType || '').toLowerCase();
                const id = treeNodeDeptId(row);
                if (type === 'class' && id && !seen.has(id)) {
                    seen.add(id);
                    ids.push(id);
                }
                const children = row.children || [];
                for (let i = 0; i < children.length; i++) {
                    walk(children[i]);
                }
            };
            walk(data);
            return ids;
        },

        /**
         * 左侧组织树选中：学校/校区/年级/班级驱动筛选。最后更新：2026-10-16
         */
        treeNodeClick(data, node) {
            if (!data) return;
            const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
            const deptId = treeNodeDeptId(data);
            if (!deptId) return;

            const schoolId = orgType === 'school' || orgType === 'affiliateschool'
                ? deptId
                : (this.findAncestorDeptId(node, 'school')
                    || this.findAncestorDeptId(node, 'affiliateschool')
                    || this.resolveSchoolId()
                    || normalizeDeptId(this.schoolId));
            if (!schoolId) return;

            this.schoolId = schoolId;
            this.boundSchoolId = schoolId;
            if (orgType === 'school' || orgType === 'affiliateschool') {
                this.schoolName = data.label || data.Name || this.schoolName;
            }

            let campusId = null;
            let classId = null;
            let classIds = null;
            if (orgType === 'campus') {
                campusId = deptId;
            } else if (orgType === 'class') {
                classId = deptId;
                campusId = this.findAncestorDeptId(node, 'campus') || null;
            } else if (orgType === 'grade' || orgType === 'period' || orgType === 'stage') {
                campusId = this.findAncestorDeptId(node, 'campus') || null;
                classIds = this.collectClassIdsFromDeptData(data);
            }

            this.filterForm.campusId = campusId;
            this.filterForm.classId = classId;
            this.filterForm.classIds = classIds;
            this.page = 1;
            this.loadTableData();
        },

        /** 组装列表/导出查询参数 */
        buildQueryParams() {
            const params = {
                page: this.page,
                intPageSize: this.pageSize,
                schoolId: this.schoolId,
                keyword: this.filterForm.keyword || ''
            };
            if (this.filterForm.campusId) params.campusId = this.filterForm.campusId;
            if (this.filterForm.classIds && this.filterForm.classIds.length) {
                params.classIds = this.filterForm.classIds.join(',');
            } else if (this.filterForm.classId) {
                params.classId = this.filterForm.classId;
            }
            if (this.filterForm.statusKey === 'expired') {
                params.onlyExpired = true;
            } else if (this.filterForm.statusKey !== null && this.filterForm.statusKey !== undefined && this.filterForm.statusKey !== '') {
                params.status = Number(this.filterForm.statusKey);
            }
            if (this.dateRange && this.dateRange.length === 2) {
                params.startTime = `${this.dateRange[0]} 00:00:00`;
                params.endTime = `${this.dateRange[1]} 23:59:59`;
            }
            return params;
        },

        async loadTableData() {
            if (!this.schoolId) return;
            // 选了年级/学段但节点下没有班级时，不退化为校区全量
            if (Array.isArray(this.filterForm.classIds) && this.filterForm.classIds.length === 0) {
                this.tableData = [];
                this.total = 0;
                return;
            }
            this.loading = true;
            try {
                const res = await getLostAndFoundListPage(this.buildQueryParams());
                if (res.data && res.data.success) {
                    const resp = res.data.response;
                    this.tableData = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            } catch (err) {
                this.$message.error('加载失物记录失败');
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.page = 1;
            this.loadTableData();
        },

        handleReset() {
            this.filterForm.keyword = '';
            this.filterForm.statusKey = null;
            this.dateRange = null;
            // 组织范围仍由左侧树决定，重置不改校区/班级
            this.page = 1;
            this.loadTableData();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.loadTableData();
        },

        handlePageChange(val) {
            this.page = val;
            this.loadTableData();
        },

        async openDetail(row) {
            this.detailVisible = true;
            this.detailLoading = true;
            this.detail = null;
            try {
                const res = await getLostAndFoundDetail({ id: row.Id, schoolId: this.schoolId });
                if (res.data && res.data.success) {
                    this.detail = res.data.response || null;
                } else {
                    this.$message.error(res.data ? res.data.msg : '加载详情失败');
                }
            } catch (err) {
                this.$message.error('加载详情异常');
            } finally {
                this.detailLoading = false;
            }
        },

        /**
         * 打开编辑：先拉详情并完成 OSS 预签回填，再弹出，避免照片区域先空后闪。创建于 2026-09-16
         */
        async openEdit(row) {
            if (!row || !row.Id || this.editOpening) return;
            this.editOpening = true;
            const loading = this.$loading({
                lock: true,
                text: '加载编辑数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.2)'
            });
            try {
                const editForm = {
                    Id: row.Id,
                    ItemName: row.ItemName || '',
                    Remark: row.Remark || ''
                };
                let editFileList = [];
                const res = await getLostAndFoundDetail({ id: row.Id, schoolId: this.schoolId });
                if (!(res.data && res.data.success)) {
                    this.$message.error(res.data ? res.data.msg : '加载详情失败');
                    return;
                }
                const d = res.data.response || {};
                editForm.ItemName = d.ItemName || editForm.ItemName;
                editForm.Remark = d.Remark || '';
                editFileList = await this.buildEditFileList(this.extractPhotoUrls(d));

                this.editForm = editForm;
                this.editFileList = editFileList;
                this.editUploadKey += 1;
                this.editVisible = true;
                this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
            } catch (err) {
                this.$message.error('加载编辑数据异常');
            } finally {
                loading.close();
                this.editOpening = false;
            }
        },

        onEditFileChange(file, fileList) {
            this.editFileList = fileList;
        },

        onEditFileRemove(file, fileList) {
            this.editFileList = fileList;
        },

        submitEdit() {
            this.$refs.editForm.validate(async (valid) => {
                if (!valid) return;
                if (!this.editFileList.length) {
                    this.$message.warning('请至少保留 1 张照片');
                    return;
                }
                if (this.editFileList.length > 9) {
                    this.$message.warning('最多 9 张照片');
                    return;
                }
                this.submitting = true;
                try {
                    const photoUrls = [];
                    for (let i = 0; i < this.editFileList.length; i++) {
                        const f = this.editFileList[i];
                        if (f.raw) {
                            const { url } = await uploadPic(f.raw, this, 'lost_and_found');
                            photoUrls.push(url);
                        } else if (f.url) {
                            photoUrls.push(stripOssPresignParams(f.url));
                        }
                    }
                    const res = await updateLostAndFound({
                        Id: this.editForm.Id,
                        ItemName: this.editForm.ItemName,
                        Remark: this.editForm.Remark,
                        PhotoUrls: photoUrls
                    });
                    if (res.data && res.data.success) {
                        this.$message.success('保存成功');
                        this.editVisible = false;
                        this.loadTableData();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '保存失败');
                    }
                } catch (err) {
                    this.$message.error(err.message || '保存异常');
                } finally {
                    this.submitting = false;
                }
            });
        },

        /** 行内「更多」下拉命令。创建于 2026-09-12 */
        handleRowCommand(cmd, row) {
            if (cmd === 'cancelClaim') this.handleCancelClaim(row);
            else if (cmd === 'retryEval') this.handleRetryEval(row);
            else if (cmd === 'void') this.openVoidDialog(row);
        },

        handleCancelClaim(row) {
            this.$confirm(`确认撤销【${row.ItemName}】的领取核销吗？记录将恢复为公示中。`, '撤销核销确认', {
                confirmButtonText: '确定撤销',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
            }).then(async () => {
                const res = await cancelLostAndFoundClaim({
                    Id: row.Id
                });
                if (res.data && res.data.success) {
                    this.$message.success('已撤销核销');
                    this.loadTableData();
                } else {
                    this.$message.error(res.data ? res.data.msg : '撤销失败');
                }
            }).catch(() => {});
        },

        openVoidDialog(row) {
            this.voidForm = { Id: row.Id, Reason: '' };
            this.voidVisible = true;
            this.$nextTick(() => this.$refs.voidForm && this.$refs.voidForm.clearValidate());
        },

        submitVoid() {
            this.$refs.voidForm.validate(async (valid) => {
                if (!valid) return;
                this.submitting = true;
                try {
                    const op = this.getOperator();
                    const res = await voidLostAndFound({
                        Id: this.voidForm.Id,
                        Reason: this.voidForm.Reason,
                        OperatorId: op.operatorId,
                        OperatorName: op.operatorName
                    });
                    if (res.data && res.data.success) {
                        this.$message.success('已作废');
                        this.voidVisible = false;
                        this.loadTableData();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '作废失败');
                    }
                } catch (err) {
                    this.$message.error('作废异常');
                } finally {
                    this.submitting = false;
                }
            });
        },

        handleRetryEval(row) {
            this.$confirm(`确认对【${row.ItemName}】补发自动点评吗？补发幂等，不会重复加分。`, '补发点评', {
                type: 'warning'
            }).then(async () => {
                const res = await retryLostAndFoundEvaluation({ id: row.Id });
                if (res.data && res.data.success) {
                    this.$message.success('补发成功');
                    this.loadTableData();
                } else {
                    this.$message.error(res.data ? res.data.msg : '补发失败');
                }
            }).catch(() => {});
        },

        async handleExport() {
            if (!this.schoolId) return;
            if (!this.total || this.total <= 0) {
                this.$message.warning('没有数据可导出');
                return;
            }
            this.exporting = true;
            try {
                const params = this.buildQueryParams();
                delete params.page;
                delete params.intPageSize;
                const response = await exportLostAndFound(params);
                if (!response.data) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const contentType = String((response.headers &&
                    (response.headers['content-type'] || response.headers['Content-Type'])) || '').toLowerCase();
                const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType });
                if (!contentType.includes('spreadsheetml') && !contentType.includes('application/octet-stream')) {
                    const message = await this.readBlobMessage(blob);
                    this.$message.error(message || '导出失败');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', '失物记录.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (err) {
                if (!err || !err.bizMessage) {
                    this.$message.error('导出失败');
                }
            } finally {
                this.exporting = false;
            }
        }
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        // 学校范围页由 DepartmentPane 初始化时自动 emit tree-node-click，避免与此处重复请求
    }
};
</script>

<style scoped>
.filter-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-shrink: 0;
}

.filter-form .el-form-item {
    margin-bottom: 6px;
}

.toolbar {
    margin-top: 8px;
    padding: 0;
    flex-shrink: 0;
}

.muted {
    color: #c0c4cc;
}

.record-table ::v-deep .el-table__body td {
    padding: 8px 0;
}

.item-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    padding: 2px 0;
}

.cover-thumb {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
}

.cover-thumb--empty {
    color: #c0c4cc;
    font-size: 18px;
}

.item-cell__text {
    min-width: 0;
    flex: 1;
}

.item-cell__name {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 1.35;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-cell__remark {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.detail-dialog-body {
    min-height: 280px;
    position: relative;
}

.detail-empty {
    min-height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 13px;
}

.detail-table th,
.detail-table td {
    border: 1px solid #ebeef5;
    padding: 8px 10px;
    vertical-align: top;
}

.detail-table th {
    width: 100px;
    background: #fafafa;
    color: #909399;
    font-weight: 500;
    text-align: right;
}

.detail-table td {
    color: #303133;
}

.photo-block {
    margin-top: 16px;
}

.photo-block__title {
    font-weight: 600;
    margin-bottom: 8px;
    color: #303133;
}

.photo-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.photo-item {
    width: 88px;
    height: 88px;
    border-radius: 4px;
}

.sub-hint {
    font-size: 12px;
    color: #909399;
    display: block;
    line-height: 1.4;
    margin-top: 4px;
}

.no-department-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
    color: #909399;
}

.no-department-tip i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #c0c4cc;
}
</style>
